import Wv3dPropertiesPanelContainer from './Wv3dPropertiesPanelContainer';

export default Wv3dPropertiesPanelContainer;
